export default __webpack_public_path__ + "static/media/Hair_2_M_C4.917b54bb.svg";